import React, { Component } from "react";
import ReactDOM from "react-dom";
import Footer from "../common/Footer";
import FormLogin from "../subcompo/sections-login/FormLogin";
import FormReset from "../subcompo/sections-login/FormReset";
import Loader from "../common/Loader";
import FormChangePass from "../subcompo/sections-login/FormChangePass";
import Header from "../common/Header";
import ImageBlock from "../subcompo/sections-home/ImageBlock";
import LoginForm from "../subcompo/sections-login/LoginForm";

class Login extends Component {
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollTop = 0;
  }
  render() {
    return (
      <div>
        {/* <Navbar variant="large-logo" /> */}
        <div className="d-flex">
          <Header />
          {/* <Stats2 /> */}
        </div>
        <div className="tab-content tab-content-login">
          <FormLogin />
          <FormReset />
          <FormChangePass />
          <Loader />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Login;
